{
  "version": 1,
  "asset_id": "988d46d0-3c5c-49b1-8b2f-ae222b91a050",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/988d46d0-3c5c-49b1-8b2f-ae222b91a050/hero-abstract-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/988d46d0-3c5c-49b1-8b2f-ae222b91a050/hero-abstract-1280.avif",
  "original_filename": "hero-abstract-1280.avif",
  "size": 38614,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:25:55Z"
}
